import React, { Component } from 'react'
import Waypoint from 'react-waypoint'
import classnames from 'classnames'
import { Link, NavLink } from 'react-router-dom'
import { throttle } from 'lodash'
import InlineSVG from 'components/InlineSVG'
import Offcanvas from './Offcanvas'

import './header.css'
import Strings from '../../../utils/translations'

class Header extends Component {
  constructor (props) {
    super(props)

    this.state = {
      sticky: false
    }

    this.scroll = 0
    this.translation = this.props.translation
    this.langPrefix = this.props.translation.currentLang === 'fr' ? '/fr' : ''

    this.toggleSticky = this.toggleSticky.bind(this)
    this.onScroll = this.onScroll.bind(this)

    this.onScrollThrottle = throttle(this.onScroll, 50)
  }

  componentDidMount () {
    document.addEventListener('scroll', this.onScrollThrottle)
  }

  componentWillUnmount () {
    document.removeEventListener('scroll', this.onScrollThrottle)
  }

  toggleSticky (current, previous) {
    const sticky = current.currentPosition === 'above'
    this.setState({ sticky })
  }

  onScroll () {
    const scroll = window.pageYOffset
    const slideUp = scroll > this.scroll

    if (this.scroll >= 0) {
      this.setState(state => {
        if (state.slideUp !== slideUp) {
          return {
            ...state,
            slideUp: slideUp
          }
        }
      })
    }

    this.scroll = scroll
  }

  render () {
    const menu = (
      <nav className='header__menu'>
        <NavLink to={Strings.menu.work.link[this.translation.currentLang]}>
          {Strings.menu.work.label[this.translation.currentLang]}
        </NavLink>
        <NavLink to={Strings.menu.expertise.link[this.translation.currentLang]}>
          {Strings.menu.expertise.label[this.translation.currentLang]}
        </NavLink>
        <NavLink to={Strings.menu.contact.link[this.translation.currentLang]}>
          {Strings.menu.contact.label[this.translation.currentLang]}
        </NavLink>
        <NavLink to={this.props.translation.targetUrl} className='header__menu-lang'>
          <InlineSVG icon='globe' />
          {this.props.translation.targetLang === 'fr' ? 'French' : 'English'}
        </NavLink>
      </nav>
    )

    return (
      <div
        className='header-wrapper'
        ref={wrapper => { this.wrapper = wrapper }}
      >
        <Waypoint onPositionChange={this.toggleSticky} bottomOffset='-1px' />
        <div className={classnames({
          'header': true,
          'header--sticky': this.state.sticky,
          'header--slide-up': this.state.slideUp
        })}>
          <div className='container-fluid'>
            <Link to='/' className='logo'>LittleBox</Link>
            <span className='offcanvas-toggle' onClick={this.props.toggleOffcanvas}>
              <InlineSVG icon='hamburger' />
            </span>
            {menu}
          </div>
        </div>
        <Offcanvas
          ref={offcanvas => { this.offcanvas = offcanvas }}
          show={this.props.offcanvas}
          toggleOffcanvas={this.props.toggleOffcanvas}
          menu={menu}
        />
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Page/Header/index.js